'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isValidPassword = function isValidPassword(password) {
  // At least 8 characters
  if (password.length < 8) return false;

  // At least one lower case letter
  if (!/[a-z]/.test(password)) return false;

  // At least one upper case letter
  if (!/[A-Z]/.test(password)) return false;

  // At least one digit
  if (!/\d/.test(password)) return false;

  // At least 1 special character
  if (!/[§±=|[\]\\!`~@#$€£%^&*()_+}{":;'?/<.>,-]/.test(password)) return false;
  return true;
};
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please choose a password that contains at least 8 characters, including at least 1 capital letter, 1 numeric value and 1 special character';
  return function (value) {
    return isValidPassword(value) ? '' : (0, _getErrorMessage2.default)(errorMessage, {
      value: value
    });
  };
};